import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormLabel,
    getWholeDivWrapperClass
} from "../../sharedStyles.tsx";



const StaticLabelRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value }) => {
    const componentWithStaticLabel = {
        ...component,
        label: value,
    };

    return (
        <div className={`${getWholeDivWrapperClass(componentWithStaticLabel)} mt-1 mb-1`}>
            <FormLabel component={componentWithStaticLabel} />
        </div>
    );
};
export const StaticLabel = React.memo(StaticLabelRenderer);